import { IBooking, IBookingAgency, IHotel, IUnbookedFlight } from "@vmosolutions/oc-interfaces";
import * as CrewTravelActions from "../actions/CrewTravel/CrewTravel.Actions";

export interface ICrewTravelState {
  unbookedFlights: IUnbookedFlight[];
  bookings: IBooking[];
  agencies: IBookingAgency[];
  hotels: IHotel[];
}

const initialState: ICrewTravelState = {
  unbookedFlights: [],
  bookings: [],
  agencies: [],
  hotels: [],
};

export const CrewTravelReducer = (
  state: ICrewTravelState = initialState,
  action: CrewTravelActions.Action
): ICrewTravelState => {
  switch (action.type) {
    case CrewTravelActions.Type.GOT_UNBOOKED_FLIGHTS:
      return {
        ...state,
        unbookedFlights: [...action.unbookedFlights],
      };
    case CrewTravelActions.Type.GOT_BOOKINGS:
      return {
        ...state,
        bookings: [...action.bookings],
      };
    case CrewTravelActions.Type.GOT_AGENCIES:
      return {
        ...state,
        agencies: Array.from(new Set([...[...state.agencies, ...action.agencies]])),
      };
    case CrewTravelActions.Type.GOT_HOTELS:
      return {
        ...state,
        hotels: [...action.hotels],
      };
    default:
      return state;
  }
};
